/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { S as Sizes, V as Variants } from './constants-c94b83bd.js';

const DHL_LOADER_SIZE = {
    SM: Sizes.SM,
    LG: Sizes.LG,
    XL: Sizes.XL,
};
const DHL_LOADER_TYPE = {
    RING: "ring",
    RING_DUAL: "ring-dual",
    RING_DONE: "ring-done",
    RING_PERCENTAGE: "ring-percentage",
};
const DHL_LOADER_VARIANT = {
    PRIMARY: Variants.primary,
    SUCCESS: Variants.success,
};
const DHL_LOADER = {
    SIZE: DHL_LOADER_SIZE,
    TYPE: DHL_LOADER_TYPE,
    VARIANT: DHL_LOADER_VARIANT,
};

export { DHL_LOADER as D };

//# sourceMappingURL=constants-a992b4c7.js.map